import { render, staticRenderFns } from "./exhibition.vue?vue&type=template&id=61ba0bfc&scoped=true"
import script from "./exhibition.vue?vue&type=script&lang=js"
export * from "./exhibition.vue?vue&type=script&lang=js"
import style0 from "./exhibition.vue?vue&type=style&index=0&id=61ba0bfc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ba0bfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61ba0bfc')) {
      api.createRecord('61ba0bfc', component.options)
    } else {
      api.reload('61ba0bfc', component.options)
    }
    module.hot.accept("./exhibition.vue?vue&type=template&id=61ba0bfc&scoped=true", function () {
      api.rerender('61ba0bfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/customManage/exhibition.vue"
export default component.exports